import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useAnalytics } from '@appcues/analytics/hooks/use-analytics';
import {
  isEntitlementEnabled,
  LOCALIZATION_ACCESS,
} from 'ext/entities/entitlements';

import { selectExperience } from 'entities/experiences/reducer';
import { selectUserPreferences } from 'entities/user-preferences/reducer';
import { updateUserPreferences } from 'entities/user-preferences/actions';
import UserPreferencesShape from 'entities/user-preferences/shape';
import { selectSelected } from 'entities/selected/reducer';
import { selectStepGroup } from 'entities/step-groups/reducer';

import ScreenShape from 'entities/screens/shape';
import { EXPERIENCE_TYPES } from 'lib/experiences';
import { PLATFORMS } from 'lib/platform';
import { capitalize } from 'utils/strings-handler';
import TopMenu from './TopMenu';

export function TopMenuManager({
  screen,
  platform,
  type,
  userPreferences,
  onUserPreferencesUpdate,
  hasLocalizationAccess,
}) {
  const { track } = useAnalytics();

  const { orientation, colorMode, direction, viewport, embed, locale } =
    userPreferences;

  const onPreferenceChange = (preference, value) => {
    track('Mobile Builder interaction', {
      name: `Selected User Preference - ${capitalize(preference)}: ${capitalize(
        value?.name ?? value
      )}`,
      component: 'TopMenuManager',
    });

    onUserPreferencesUpdate(preference, value);
  };

  return (
    <TopMenu
      colorMode={colorMode}
      direction={direction}
      orientation={orientation}
      screen={screen}
      viewport={viewport}
      platform={platform}
      embed={embed}
      locale={locale}
      experienceType={type}
      onPreferenceChange={onPreferenceChange}
      hasLocalizationAccess={hasLocalizationAccess}
    />
  );
}

TopMenuManager.propTypes = {
  screen: ScreenShape,
  platform: PropTypes.oneOf(PLATFORMS),
  type: PropTypes.oneOf(EXPERIENCE_TYPES),
  userPreferences: UserPreferencesShape,
  onUserPreferencesUpdate: PropTypes.func,
  hasLocalizationAccess: PropTypes.bool,
};

const mapStateToProps = state => {
  const { platform, type } = selectExperience(state) ?? {};
  const { stepGroup } = selectSelected(state) ?? {};
  const { editor } = selectStepGroup(state, stepGroup) ?? {};
  const { screen } = editor ?? {};
  const userPreferences = selectUserPreferences(state);
  const hasLocalizationAccess = isEntitlementEnabled(
    state,
    LOCALIZATION_ACCESS,
    { type: 'boolean' }
  );

  return {
    screen,
    platform,
    type,
    userPreferences,
    hasLocalizationAccess,
  };
};

const mapDispatchToProps = {
  onUserPreferencesUpdate: updateUserPreferences,
};

export default connect(mapStateToProps, mapDispatchToProps)(TopMenuManager);
